<!-- 情书贺卡 -->
<template>
  <div class="createPlayStep new-input-box">
    <!-- 头部返回 -->
    <div class="backBox">
      <jd-button type="blue" :styleTextObj="{
        width: '44px',
        height: '24px',
        'line-height': '24px',
        padding: '0 8px',
        'min-width': '44px',
      }" @click="returnBack()">返回</jd-button>
      <span class="backBox_name">{{ activityData.name }}</span>
    </div>
    <div class="formBox">
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="localStepNum">
          <!-- <el-step title="活动模板"></el-step> -->
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>

      <!-- 选中活动模板 -->

      <!-- 活动条件表单设置 -->
      <billetDoux ref="billetDoux" :activityData="activityData" :templateId="templateId" :giftList="giftList" @selectTemplateFn="selectTemplateFn"
        :backgroundOpacity="backgroundOpacity" :isDraftEdit="isDraftEdit" @returnBack="returnBack" :ids="ids"
        :selectTemplate="selectTemplate" @changevalueRow="changevalueRow" @saveDraftBack="saveDraftBack">
      </billetDoux>

    </div>
    <div class="create_bottom">
      <jd-button v-if="backgroundOpacity" v-show="!itemId" @click="clickLocalStep()" style="margin-right: 8px">{{ backgroundOpacity ? "返回列表" :
        "返回上一步" }}</jd-button>
      <jd-button @click="saveDraft" style="margin-right: 8px" v-if="hasDraftBtn">保存至草稿箱</jd-button>
      <template v-if="!backgroundOpacity">
        <jd-button v-show="!itemId" v-if="isSave" @click="saveAndFinish" v-preventReClick
          type="blue">保存设置</jd-button>
      </template>

      <jd-button v-show="itemId" size="medium" @click="cancelEdit" style="margin-right: 8px">取消</jd-button>
      <jd-button v-show="itemId" type="blue">保存设置</jd-button>
    </div>

    <!-- 保存并完成设置弹框 -->
    <el-dialog title="重要提示" :visible.sync="joinBlackList" width="800">
      <div style="line-height: 25px; margin-bottom: 30px">
        <p>
          1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
        </p>
        <p>
          2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
        </p>
      </div>

      <el-checkbox v-model="checked" label="地址" name="partner">我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox>
      <div slot="footer" class="dialog-footer">
        <el-button @click="joinBlackList = false">取 消</el-button>
        <el-button @click="handleDialogCloseAnoth()" type="primary">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import selectProduct from "./select_product";
import QRCode from "qrcodejs2";
import {
  hdTaskTemplateGroup,
  sellerImage,
} from "@/api/jhk/paradiseAndTaskCommonController.js";
import selectGoodsMonitor from "@/components/selectGoodsMonitor2.vue";
import draggable from "vuedraggable";
import addPrizeNum from "./components/add-prize-num.vue";
import selectPeople from "@/components/select-people-yunqi.vue";
import billetDoux from "@/views/interactiveMarketing/activity/components/billetDoux/index.vue";

export default {
  components: {
    selectProduct,
    selectGoodsMonitor,
    draggable,
    addPrizeNum,
    selectPeople,
    billetDoux,
  },
  props: {
    itemId: "",
    stepNum: {
      type: Number,
      default: 0,
    },
    activityData: {
      type: Object,
    },
    ids: {
      type: String,
      default: "",
    },
    isSave: {
      type: Boolean,
      default: true,
    },
    backgroundOpacity: {
      type: Boolean,
      default: false,
    },
    isDraftEdit: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      localStepNum: this.stepNum, // 将外部传入的步骤赋值到本地，避免直接更改props
      // 模板名称列表
      tempSwitchList: [
        {
          isVisible: true,
          title: "全部",
          id: -1,
        },
      ],
      // 选择的模板
      selectTemplate: {},
      // 模板列表
      giftList: [],
      templateId: "",
      tabActive: 0,
      navItem: {},
      pageData: {
        size: 10000,
        current: 1,
        total: 0,
      },
      valueRow: null,
      qrcode: null,
      joinBlackList: false,
      checked: false,
      sharePic: "",
      activityStartTime: null,
      activityEndTime: null,
      index: 0,
      itemArr: [],
      isDraft: false,
      ruleForm: {
        exposureSwitch: false,
        radio: 0,
        activityName: "",
        startTime: "",
        endTime: "",
        condFollow: false, // 活动条件
        ruleDescription: "",
        partner: ["-1"],
        // 分享设置
        shareTitle: "",
        shareIntroduce: "",
        sharePic: "",
        timeType: 'day',
        settingType: 2,
        blessingText: "",
        memberLevels: ["-1"], // 可领奖等级
        limitPerPerson: 0, // 每人领奖限制
        theme: "", // 活动主题
        description: ""// 活动说明
      },
    };
  },
  async created() {
    console.log("当前玩法id", this.activityData.id);;
    this.hdTaskTemplateGroup();
  },
  computed: {
    // 判断是否有草稿箱按钮
    hasDraftBtn() {
      return this.isDraftEdit || !this.valueRow || this.activityData.isCopy;
    },
    isDisabled() {
      return this.activityData.isStart || this.backgroundOpacity;
    },
  },
  methods: {
    selectTemplateFn(index,id,items){
      this.selectTemplate = items;
      console.log("--- this.selectTemplate:---", this.selectTemplate)
      this.$nextTick(()=>{
        this.$refs.billetDoux.setDefaultVaule()
      })
      // this.$emit("selectTemplateFn",index,id,items)
    },
    handleNav(item, index) {
      this.tabActive = index;
      this.navItem = item;
      this.getPolite();
    },
    // 返回上一步
    returnBack() {
      if (this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      if (this.localStepNum == 0) this.$emit("returnBack");
      if (this.localStepNum == 1) this.localStepNum = 0;
      if (this.isDisabled) {
        this.$emit("returnBack");
      }
    },
    // 保存草稿并返回
    saveDraftBack() {
      this.$emit("returnBack", true);
    },
    // 品牌定制弹窗
    handleOpen() {
      const href =
        "tencent://message/?uin=800152084&Site=%E5%9C%A8%E7%BA%BF%E5%AE%A2%E6%9C%8D&Menu=yes";
      window.open(href, "_self");
    },
    // 点击下单时间显示提示
    orderFocus() {
      if (this.activityData.isStart) {
        this.isShowTip = true
      }
    },
    clearNewTime() {
      this.ruleDto.openCardStartTime = "";
      this.ruleDto.openCardEndTime = "";
    },

    inp(val) {
      this.$forceUpdate();
    },
    // 模板类型获取
    async hdTaskTemplateGroup() {
      const { data } = await hdTaskTemplateGroup({
        hdTaskType: this.activityData.id,
      });
      this.tempSwitchList = [
        {
          id: -1,
          groupName: "全部",
          frontHide: false,
        },
        ...data,
      ];
      this.tempSwitchList.map((item) => {
        item.isVisible = true;
        item.title = item.groupName;
      });
      this.getPolite();
    },

    // 活动模板
    async getPolite() {
      let params = {
        current: this.pageData.current,
        size: this.pageData.size,
        templateGroupId: this.navItem.id == -1 ? "" : this.navItem.id,
        source: 4,
        hdTaskType: this.activityData.id,
      };
      const { data } = await sellerImage(params);
      // 获取模板
      this.giftList = data.records.map((item) => {
        return {
          ...item,
          days: item.activityStartTime
            ? this.getDaysBetween(item.activityStartTime, item.activityEndTime)
            : "",
        };
      });
      this.pageData.total = data.total * 1;
      if(!this.$refs.billetDoux.templateId){
        this.selectTemplateFn(0,this.giftList[0].id,this.giftList[0])
      }
      this.$nextTick(() => {
        this.getCodeIMG();
      });
    },
    getDaysBetween(dateString1, dateString2) {
      const startDate = Date.parse(dateString1);
      const nowDate = Date.parse(new Date());
      // console.log(nowDate,startDate);
      const endDate = Date.parse(dateString2);
      if (startDate > endDate) {
        return 0;
      }
      if (startDate == endDate) {
        return 1;
      }
      let days = 0;
      if (nowDate > startDate) {
        days = (endDate - nowDate) / (1 * 24 * 60 * 60 * 1000);
      } else {
        days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
      }
      // console.log(days);

      return Math.floor(days) == 0 ? "1天" : Math.ceil(days) + "天";
    },
    nextStepKai(item) {
      this.selectTemplate = item;
      console.log("--- this.selectTemplate:---", this.selectTemplate)
      this.localStepNum = 1;
    },
    getCodeIMG() {
      const codeImg = document.querySelectorAll(".qrCodeIMG");
      for (let index = 0; index < codeImg.length; index++) {
        const elementbox = codeImg[index];
        elementbox.innerHTML = "";
      }
      let url = "https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg="
      // const codeImg = this.$refs[queryIdIMG];
      for (let index = 0; index < codeImg.length; index++) {
        const element = codeImg[index];
        new QRCode(element, {
          width: 140, // 设置宽度，单位像素
          height: 140, // 设置高度，单位像素
          // text: url, // 设置二维码内容或跳转地址
          text: url + this.giftList[index].imageUrl,
        });
      }
    },
    //生成二维码
    qrcodeAll(val, queryId) {
      this.qrcode = new QRCode(queryId, {
        width: 140, // 设置宽度，单位像素
        height: 140, // 设置高度，单位像素
        text: val, // 设置二维码内容或跳转地址
      });
    },

    // 取消编辑
    cancelEdit() {
      this.$emit("cancelEdit");
    },
    //深拷贝
    deepClone(obj) {
      let theObj = JSON.stringify(obj),
        objClone = JSON.parse(theObj);
      return objClone;
    },
    // 创建活动
    saveAndFinish() {
      this.$refs.billetDoux.isDraft = false;
      this.$refs.billetDoux.saveAndFinish()
    },
    // 保存草稿
    saveDraft() {
      this.$refs.billetDoux.saveDraft()
    },
    // 返回上一步
    clickLocalStep() {
      if (this.backgroundOpacity) {
        this.$emit("returnBack");
        return;
      }
      if (!this.activityData.isCopy && this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      this.$emit("returnBack");
      // this.localStepNum = 0;
    },
    changevalueRow(val) {
      this.valueRow = val;
    }
  },
};
</script>

<style lang="scss" scoped>
.prosi {
  position: absolute;
  bottom: 107px;
  right: 38px;
}

.createPlayStep {
  min-width: 1046px;
  position: relative;
  box-sizing: border-box;
  height: 100%;
  background-color: #fff;
  border-radius: 6px;

  .headReturn {
    box-sizing: border-box;
    padding-left: 30px;
    width: 100%;
    height: 50px;
    line-height: 49px;
    border-bottom: 1px solid #f3f3f3;

    span {
      color: #ccc;
      cursor: pointer;
    }

    .name {
      color: #333;
      cursor: default;
    }
  }

  .step {
    padding: 30px 24px 0;

    .bz {
      display: flex;
      justify-content: center;
      height: 18px;
      // border-bottom: 1px solid #f3f3f3;
    }
  }

  .firststep {
    box-sizing: border-box;
    padding: 35px 35px 0;

    .itemList {
      display: flex;

      .item {
        box-sizing: border-box;
        position: relative;
        color: #666;
        text-align: center;
        padding: 6px;

        &:hover {

          .border::before,
          .border::after {
            opacity: 1;
            transform: scale(1);
          }
        }

        .border {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          border-radius: 4px;

          &::before,
          &::after {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            content: "";
            opacity: 0;
            pointer-events: none;
            transition: opacity 0.8s, transform 0.8s;
            border-radius: 4px;
          }

          &::before {
            border-top: 1px solid #2768ff;
            border-bottom: 1px solid #2768ff;
            -webkit-transform: scale(0, 1);
            transform: scale(0, 1);
          }

          &::after {
            border-right: 1px solid #2768ff;
            border-left: 1px solid #2768ff;
            -webkit-transform: scale(1, 0);
            transform: scale(1, 0);
          }
        }

        .wrapper {
          position: relative;
          height: 350px;
          border-radius: 6px;
          overflow: hidden;
          width: 206px;

          &:hover {
            .mask {
              opacity: 1;
            }
          }

          .mask {
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.6);
            color: #fff;
            opacity: 0;
            transition: all 0.2s;

            .img {
              max-width: 130px;
              margin: 0 auto 30px;

              .imgBg {
                box-sizing: border-box;
                height: 129px;
                width: 129px;
                padding: 6px;
                border-radius: 6px;
                background-color: #fff;
              }

              .tpl {
                display: inline-block;
                margin-top: 4px;
                opacity: 0.7;
              }
            }
          }
        }
      }
    }
  }

  .secondstep {
    box-sizing: border-box;
    position: relative;
    padding: 0px 28px 1px 24px;
    margin-bottom: 29px;

    .zd {
      width: 360px;
    }

    .time2 {
      width: 54px;
      height: 28px;
      border-radius: 4px;
      display: inline-block;
      text-align: center;
      line-height: 28px;
    }

    .lastTime {
      margin-left: 20px;
      font-size: 14px;

      i {
        color: #ccc;
      }
    }

    .limit {
      display: flex;
      flex-direction: column;

      p {
        margin: 0;

        &:nth-child(2) {
          margin: 16px 0;
        }
      }

      .c {
        color: #2768ff;
      }

      .desc {
        i {
          opacity: 0.7;
          color: #2768ff;
        }

        color: #999;
      }

      /deep/ .el-input {
        margin: 0 6px;
      }
    }

    .img {
      display: inline-block;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background-color: #eeeeee;
    }

    .tips {
      display: flex;
      flex-direction: column;
      margin-top: 16px;
      box-sizing: border-box;
      padding: 13px 30px;
      background: #fffaee;
      font-size: 13px;
      color: #333;

      i {
        color: #fe8f8a;
        opacity: 0.7;
      }

      p {
        margin: 0;
        line-height: 20px;
        padding-left: 18px;
      }
    }

    .generate {
      width: 76px;
      margin-top: 8px;
      background: rgba(127, 133, 233, 0.1);
      border: 1px solid rgba(127, 133, 233, 1);
      color: #7f85e9;
    }

    .termAdd {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 6px;
      color: #333;

      p {
        margin: 0;
      }

      .add {
        margin-left: 4px;
        color: #2768ff;
      }
    }

    .set {
      display: inline-block;
      margin-top: 30px;
    }

    .desc {
      margin-left: 20px;
      color: #999;
      font-size: 13px;

      i {
        color: #fe8f8a;
        opacity: 0.7;
        font-size: 13px;
      }
    }

    .s {
      color: #2768ff;
      cursor: pointer;
    }

    .returnBtn {
      width: 148px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid #2768ff;
      color: #2768ff;
      transition: all 0.2s;

      &:hover {
        background-color: #2768ff;
        color: #fff;
      }
    }

    .keepBtn {
      margin-left: 30px;
      width: 188px;
      background-color: #2768ff;
      color: #fff;
      transition: all 0.2s;

      &:hover {
        opacity: 0.9;
      }
    }

    /deep/ .el-table .el-table__header-wrapper th .cell {
      text-align: center;
      font-weight: 500;
    }

    /deep/ .el-table .el-table__header-wrapper th {
      border-right: 1px solid #f0f0f0;

      &:last-child {
        border-right: none;
      }
    }

    /deep/ .el-table--enable-row-transition .el-table__body td {
      text-align: center;
      border-right: 1px solid #f0f0f0;

      &:last-child {
        border-right: none;
      }
    }
  }
}
</style>
<style lang="scss">
.createPlayStep {
  .textarea {
    .el-textarea__inner {
      min-height: 120px !important;
    }
  }

  .el-step {
    position: relative;
  }
}
</style>
